import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { login } from '../services/api';
import { setAuthToken, setAdminInfo } from '../services/auth';
import './Login.css';

function Login({ onLogin }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(email, password);
      if (response.requires_mfa) {
        // Weiterleitung zu MFA-Verification
        navigate('/admin/mfa', { state: { email, password } });
      } else if (response.token) {
        // Direktes Login ohne MFA
        setAuthToken(response.token);
        setAdminInfo(response.admin);
        if (onLogin) {
          onLogin(response.token);
        }
        navigate('/admin/dashboard');
      } else {
        setError(t('admin_login.errors.unexpected_server_response'));
      }
    } catch (err) {
      setError(err.message || t('admin_login.errors.login_failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-card">
        <h1>{t('admin_login.title')}</h1>
        <form className="login-form" onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          <input
            type="email"
            placeholder={t('admin_login.email_placeholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
          <input
            type="password"
            placeholder={t('admin_login.password_placeholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <button type="submit" disabled={loading}>
            {loading ? t('admin_login.buttons.logging_in') : t('admin_login.buttons.login')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;






